import { render, staticRenderFns } from "./decoration11.vue?vue&type=template&id=0171b947&scoped=true"
import script from "./decoration11.vue?vue&type=script&lang=js"
export * from "./decoration11.vue?vue&type=script&lang=js"
import style0 from "./decoration11.vue?vue&type=style&index=0&id=0171b947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0171b947",
  null
  
)

export default component.exports